import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import routes from 'src/routes';
import Page from 'src/components/Page';

function OverviewPage() {
  
    return <Page header="Overview">
        <p>
            This section covers the many different methods for implementing payment and token solutions based on your business requirements.
        </p>

        <p>
            The two main approaches are 2-party and 3-party integration.  Even though there are three parties invovled in successfully processing a payment,
            the focus when discussing both paradigms is on which party is involved in handling the payment details.
        </p>

        <h2>2-party integration</h2>
        <p>
            In a 2-party integration, payment details are exposed by the Customer to the Merchant.  In this case, the Merchant must follow
            strict PCI DSS compliance requirements in relation to how payment details are collected and stored.
        </p>
        <p>
            BPoint has two 2-party APIs:
            <ul>
                <li>2-party without AuthKey - Allows for straight through payment processing with one API call.  See <Link to={routes.api.spec + "#tag/Txn/operation/Txn_Process"}>Process Transaction</Link>.</li>
                <li>2-party without AuthKey - Allows for the creation of tokens with one API call.  See <Link to={routes.api.spec + "#tag/Token/operation/Token_AddToken"}>Add Token</Link>.</li>
                <li>2-party with AuthKey - Offers support for Authentication (using 3D Secure), Fraud Screening, Customer and Order Details collection, to name some of the features.</li>
            </ul>
        </p>

        <h2>3-party integration</h2>
        <p>
            In a 3-party integration, the customer loads a merchant-hosted payments website and enters their card details, but the card details are sent from the browser directly to BPoint, 
            thus bypassing the merchant's infrastructure.  The Merchant benefits from 3-party integration by reducing their PCI DSS compliance scope because they cannot handle, view or
            store the payment details.
        </p>
        <p>
            BPoint has three 3-party APIs:
            <ul>                
                <li>JavaScript Simple - Allows you to integrate with minimal JavaScript code. BPoint handles the creation of the form and the submission of the payment details.</li>
                <li>JavaScript Advanced - Allows you to integrate with greater control of the form and user interaction. You handle the creation of the form and submission of payment details.</li>
                <li>Iframe fields - Each payment control such as Card Number, Expiry, CVN and Card Holder Name are each embedded within an iFrame.</li>
            </ul>
        </p>

        <p>
            Visit <Link to={routes.api.txn.authkey.flow}>Transaction flow</Link> and <Link to={routes.api.token.authkey.flow}>Token flow</Link> to visualise 2-party and 3-party processing.
        </p>
         
    </Page>
}

export default OverviewPage;